<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-list-item-title class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        name: 'qsb-property-panel',
        mixins: [KubernetesPanel],
        computed: {
            descriptionText() {
                return 'QuotaSpecBinding'
            },
        },
        data: function () {
            return {
            }
        },
        watch: {
        },
        methods: {
        }
    }
</script>

